import script from "./user-modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./user-modal.vue?vue&type=script&lang=ts&setup=true"

import "./user-modal.vue?vue&type=style&index=0&id=9d4b7654&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d4b7654"]])

export default __exports__